// extracted by mini-css-extract-plugin
export default {"backLink":"Basics_backLink__MrC4N","hideContent":"Basics_hideContent__U-5vq"};